import * as trace from 'owa-trace';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';

export default function getAvailableLocalAttachmentSize(
    viewState: AttachmentWellViewState
): number {
    const availableSize =
        viewState.maxTotalClassicAttachmentSize - viewState.totalClassicAttachmentSize;
    if (availableSize < 0) {
        /* VSTO: 55176 remove this after figuring out why allowed attachment size is smaller than 0.
        When loading from draft, it could happen that the availableSize is smaller than zero.
        As when inserting attachment, we use the size of the original file in the disk.
        But after saving it to server, the size of attachment is bigger than the original size.
        It is ok to have this offset as we already consider the overhead when setting the maximum attachment size. */
        trace.errorThatWillCauseAlert(
            'AttachmentWellAvailableSize is smaller than zero: ' + viewState.composeId
        );
        return 0;
    } else {
        return availableSize;
    }
}
